import axios from 'axios';

// Use empty string for production (same-origin), localhost for development
const API_BASE_URL = process.env.REACT_APP_API_URL !== undefined
  ? process.env.REACT_APP_API_URL
  : 'http://localhost:8100';

export type Verschmutzungsgrad = 'STARK' | 'MITTEL' | 'LEICHT';

export interface Zeitaufzeichnung {
  id: number;
  datum: string;  // YYYY-MM-DD
  beginn: string; // HH:MM
  ende: string;   // HH:MM
  mittagspause_minuten: number;
  verschmutzungsgrad?: Verschmutzungsgrad | null;
  notiz: string;
  arbeitszeit_stunden: string;
  erstellt_am: string;
  aktualisiert_am: string;
}

export interface ZeitaufzeichnungCreate {
  datum: string;
  beginn: string;
  ende: string;
  mittagspause_minuten: number;
  verschmutzungsgrad?: Verschmutzungsgrad | null;
  notiz?: string;
}

export interface ZeitaufzeichnungUpdate {
  datum?: string;
  beginn?: string;
  ende?: string;
  mittagspause_minuten?: number;
  verschmutzungsgrad?: Verschmutzungsgrad | null;
  notiz?: string;
}

class ZeitaufzeichnungAPI {
  /**
   * Fetch all Zeitaufzeichnungen for a specific month
   * @param month - Month in YYYY-MM format
   * @param token - Bearer token for authentication
   */
  async fetchZeitaufzeichnungen(month: string, token: string): Promise<Zeitaufzeichnung[]> {
    const response = await axios.get<any>(
      `${API_BASE_URL}/api/v1/zeitaufzeichnung/`,
      {
        params: { month },
        headers: {
          Authorization: `Bearer ${token}`
        }
      }
    );
    // Handle paginated response from DRF
    return response.data.results || response.data;
  }

  /**
   * Create a new Zeitaufzeichnung
   * @param data - Zeitaufzeichnung data
   * @param token - Bearer token for authentication
   */
  async createZeitaufzeichnung(
    data: ZeitaufzeichnungCreate,
    token: string
  ): Promise<Zeitaufzeichnung> {
    const response = await axios.post<Zeitaufzeichnung>(
      `${API_BASE_URL}/api/v1/zeitaufzeichnung/`,
      data,
      {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }
    );
    return response.data;
  }

  /**
   * Update an existing Zeitaufzeichnung
   * @param id - Zeitaufzeichnung ID
   * @param data - Updated data
   * @param token - Bearer token for authentication
   */
  async updateZeitaufzeichnung(
    id: number,
    data: ZeitaufzeichnungUpdate,
    token: string
  ): Promise<Zeitaufzeichnung> {
    const response = await axios.patch<Zeitaufzeichnung>(
      `${API_BASE_URL}/api/v1/zeitaufzeichnung/${id}/`,
      data,
      {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }
    );
    return response.data;
  }

  /**
   * Delete a Zeitaufzeichnung
   * @param id - Zeitaufzeichnung ID
   * @param token - Bearer token for authentication
   */
  async deleteZeitaufzeichnung(id: number, token: string): Promise<void> {
    await axios.delete(
      `${API_BASE_URL}/api/v1/zeitaufzeichnung/${id}/`,
      {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }
    );
  }
}

export const zeitaufzeichnungAPI = new ZeitaufzeichnungAPI();
